"use server";

import { requestPasswordReset } from "@/server/auth/password-reset";

export type ForgotState = { error: string } | { sent: true } | null;

export async function forgotPassword(
  _prev: ForgotState,
  formData: FormData,
): Promise<ForgotState> {
  const res = await requestPasswordReset(String(formData.get("email") ?? ""));
  return "error" in res && res.error ? { error: res.error } : { sent: true };
}
